import { useEffect } from 'react';

import type { SessionData } from '../../../../public-src/core/js/schibsted-account/types.js';
import type { SiteVersion } from '../../../core/system/rendering/types.js';

const useInitializeAds = (
  session: SessionData | null,
  siteVersion: SiteVersion,
) => {
  useEffect(() => {
    if (session !== null) {
      import('../../../../public-src/byfunn/js-chunks/ads.js').then(
        ({ initAds }) => {
          initAds(siteVersion);
        },
      );
    }
  }, [session, siteVersion]);
};

export default useInitializeAds;
